import { FormattedMessage, useIntl } from 'react-intl';

import firstImage from '@/images/DamagesInbox.png';

const DamagesInbox = () => {
    const intl = useIntl();
    const altImageText = intl.formatMessage({ id: 'intl-msg:fleetstatus.info.damages_inbox' });

    return (
        <>
            <p className="text-size-h2 text-thin">
                <FormattedMessage id="intl-msg:fleetstatus.info.damages_inbox" />
            </p>

            <div>
                <img src={firstImage} alt={altImageText} className="width-100pct" />
                <h3 className="text-size-20">
                    <FormattedMessage id="intl-msg:fleetstatus.info.damages_inbox.headline" />
                </h3>
            </div>

            <div className="row">
                <div className="col-sm-6">
                    <p>
                        <FormattedMessage
                            id="intl-msg:fleetstatus.info.damages_inbox.description"
                            values={{
                                linebreak: <br />,
                            }}
                        />
                    </p>
                </div>
                <div className="col-sm-6">
                    <p>
                        <FormattedMessage id="intl-msg:fleetstatus.info.damages_inbox.proceed_options" />

                        <ul className="padding-left-15">
                            <li>
                                <FormattedMessage
                                    id="intl-msg:fleetstatus.info.damages_inbox.proceed_options.wont_fix"
                                    values={{
                                        damageAction: (
                                            <span className="text-bold">
                                                <FormattedMessage id="intl-msg:fleetstatus.damages.status.wont_fix" />
                                            </span>
                                        ),
                                    }}
                                />
                            </li>
                            <li>
                                <FormattedMessage
                                    id="intl-msg:fleetstatus.info.damages_inbox.proceed_options.damage_repaired"
                                    values={{
                                        damageAction: (
                                            <span className="text-bold">
                                                <FormattedMessage id="intl-msg:fleetstatus.info.damages_inbox.repaired" />
                                            </span>
                                        ),
                                    }}
                                />
                            </li>
                            <li>
                                <FormattedMessage
                                    id="intl-msg:fleetstatus.info.damages_inbox.proceed_options.request_workshop_appointment"
                                    values={{
                                        damageAction: (
                                            <span className="text-bold">
                                                <FormattedMessage id="intl-msg:fleetstatus.damages.user_action.request_workshop_appointment" />
                                            </span>
                                        ),
                                    }}
                                />
                            </li>
                        </ul>
                    </p>
                </div>
            </div>
        </>
    );
};

export default DamagesInbox;
